import { tidy, rename } from '@tidyjs/tidy'
import {CountSubGroups} from "./Calculations";

function transformNumericGroupings(data, variable, customAction) {
  return data.map((item) => {
    if (item.hasOwnProperty(variable)) {
      const numericgroupingsValue = parseInt(item[variable]);
      if (!isNaN(numericgroupingsValue)) {
        for (let i = 0; i < customAction.length; i++) {
          const [lower, upper, group] = customAction[i];
          if (numericgroupingsValue >= lower && numericgroupingsValue <= upper) {
            return { ...item, [variable]: group };
          }
        }
      }
    }
    return { ...item };
  });
}

function transformData(data, variable, type, customAction) {
  return data.map((item) => {
    if (!item.hasOwnProperty(variable)) {
      return { ...item };
    }

    if (type === 'numericgroupings' && Array.isArray(customAction) && customAction.length > 0) {
      return transformNumericGroupings([item], variable, customAction)[0];
    } else if (type === 'case_when' && customAction[item[variable]]) {
      return { ...item, [variable]: customAction[item[variable]] };
    } else if (type === 'date') {
      return { ...item, [variable]: new Date(item[variable]).toLocaleDateString() };
    } else if (type === 'string' && typeof customAction === 'function') {
      return { ...item, [variable]: customAction(item[variable]) };
    } else if (type === 'multi_column' && typeof customAction === 'function') {
      return { ...item, [variable]: customAction(item[variable], item) };
    } else {
      return { ...item };
    }
  });
}

export function WrangleMemberData(data, optionalVariables = []) {
  data = data.map((item) => {
    for (const key in item) {
      if (item.hasOwnProperty(key) && item[key] === null) {
        item[key] = "Unknown";
      }
    }
    return item;
  });
  
  if (optionalVariables && optionalVariables.length > 0) {
    optionalVariables = optionalVariables.map((variableArray) => {
      let variable, varName, newVariable, type, customAction;
      if (variableArray.length === 5) {
        [variable, varName, newVariable, type, customAction] = variableArray;
      } else if (variableArray.length === 4 && typeof variableArray[2] === 'boolean') {
        [variable, varName, type] = [variableArray[0], variableArray[1], variableArray[3]];
        newVariable = variableArray[2];
        customAction = "N/A";
        return [variable, varName, newVariable, type, customAction];
      } else if (variableArray.length === 4) {
        [variable, varName, type, customAction] = variableArray;
        newVariable = undefined;
        return [variable, varName, newVariable, type, customAction];
      } else if (variableArray.length === 3) {
        [variable, varName, type] = variableArray;
        newVariable = undefined;
        customAction = undefined;
        return [variable, varName, newVariable, type, customAction];
      }
      return variableArray;
    });

    optionalVariables.forEach((variableArray) => {
      let [variable, varName, newVariable, type, customAction] = variableArray;

      if (!data.some((item) => item.hasOwnProperty(variable))) {
        return;
      }

      let transformedData;
      if (type === 'numericgroupings' && Array.isArray(customAction) && customAction.length > 0) {
        transformedData = transformNumericGroupings(data, variable, customAction);
      } else {
        transformedData = transformData(data, variable, type, customAction);
      }

      if (newVariable) {
        data = data.map((item, index) => {
          return { ...item, [varName]: transformedData[index][variable] };
        });
      } else {
        data = transformedData;
      }
    });
  }

  return tidy(
    data,
    rename(
      optionalVariables.reduce((acc, [variable, varName,newVariable]) => {
        if (!newVariable || newVariable === "Unknown") {
          acc[variable] = [varName];
      }
        return acc;
      }, {})
    ),
  );
}

export function NewMemberMonthData(memberData) {
  const addLeadingZero = (number) => (number < 10 ? `0${number}` : number);
  const currentYear = new Date().getFullYear();
  const lastYear = currentYear - 1;
  const transformedData = memberData.map(obj => {
    const joinedDate = new Date(obj.JOINED_DATE);
    const joinYear = joinedDate.getFullYear();
    const joinMonth = addLeadingZero(joinedDate.getMonth() + 1); // Month is 0-indexed

    return {
      ...obj,
      joinYear: joinYear,
      joinMonth: joinMonth

    };
  });

  const filteredData = CountSubGroups(
      transformedData,
      [
        ["joinMonth", "id", "Unknown"],
        ["joinYear", "Key", "Unknown"],
      ]
  ).filter(item => [lastYear, currentYear].includes(item.Key));
  let chartdata = filteredData.reduce((acc, current) => {
    const foundItem = acc.find(item => item.id === current.id);
    if (!foundItem) {
      const newItem = {
        id: current.id,
        'Key 1': 0,
        'Key 2': 0
      };
      if (current.Key === lastYear) {
        newItem['Key 1'] = current.value;
      } else if (current.Key === currentYear) {
        newItem['Key 2'] = current.value;
      }
      acc.push(newItem);
    } else {
      if (current.Key === lastYear) {
        foundItem['Key 1'] = current.value;
      } else if (current.Key === currentYear) {
        foundItem['Key 2'] = current.value;
      }
    }
    return acc;
  }, []);
  chartdata = chartdata.slice().sort((a, b) => parseInt(a.id, 10) - parseInt(b.id, 10));
  const monthMap = {
    "01": "Jan",
    "02": "Feb",
    "03": "March",
    "04": "April",
    "05": "May",
    "06": "June",
    "07": "July",
    "08": "Aug",
    "09": "Sept",
    "10": "Oct",
    "11": "Nov",
    "12": "Dec"
  };

// Replace string numbers with corresponding month names
   chartdata = chartdata.map(obj => {
    return {
      ...obj,
      id: monthMap[obj.id]
    };
  });


  return(chartdata)

}

